import FooterNavbar from "../../footernavbar/FooterNavbar";

const Magzines = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <section className="py-5">
          <div className="container">
            <div className="row mt-0 w-90 mx-auto jus">
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-1.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">
                     D Suraj Ahamed
                    </h5>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                    Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-2.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">
                      Natalie Paisley
                    </h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Natalie Paisley
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-3.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Mark Audrey</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Bella Audrey
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-4.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Wang Skylar</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Mila Skylar
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-5.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Wang Skylar</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Mila Skylar
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-6.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Wang Skylar</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Mila Skylar
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4 w-90 mx-auto jus">
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-13.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">
                      Miriam Lendra
                    </h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Miriam Lendra
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-14.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">
                      Natalie Paisley
                    </h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Natalie Paisley
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-15.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Mark Audrey</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Bella Audrey
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-16.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Wang Skylar</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Mila Skylar
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-17.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Wang Skylar</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Mila Skylar
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-18.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Wang Skylar</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Mila Skylar
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4 w-90 mx-auto jus">
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-7.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">
                      Miriam Lendra
                    </h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Miriam Lendra
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-8.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">
                      Natalie Paisley
                    </h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Natalie Paisley
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-9.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Mark Audrey</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Bella Audrey
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-10.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Wang Skylar</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Mila Skylar
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-11.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Wang Skylar</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Mila Skylar
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-6 mb-lg-0 mb-4">
                <div className="card shadow-lg">
                  <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                    <a href="/MagzinesInside" className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/magzines/magzine-12.jpg"
                        alt="img-blur-shadow"
                        className="img-fluid shadow border-radius-lg"
                      />
                    </a>
                  </div>
                  <div className="card-body text-center bg-white border-radius-lg p-3 pt-0">
                    <h5 className="mt-3 mb-1 d-md-block d-none">Wang Skylar</h5>
                    <p className="mb-1 d-md-none d-block text-sm font-weight-bold text-darker">
                      Mila Skylar
                    </p>
                    <p className="mb-0 text-xs font-weight-bolder text-warning text-gradient text-uppercase">
                      Founder & CEO
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Magzines;
